<template>
  <layout name="Settings">
    <div class="account-integrations__wrapper">
      <VSettingsSidebarLayoutHeading
        title="API / Integrations"
      ></VSettingsSidebarLayoutHeading>

      <div class="account-integrations__inner">
        <div class="inner__item">
          <div class="subheader">
            <span>
              API Tokens
            </span>

            <div
              class="regenerate"
              :class="{ ['hovered']: hovered }"
              @mouseover="hovered = true"
              @mouseleave="hovered = false"
              @click="refreshToken()"
            >
              <div class="regenerate__item-logo">
                <div class="regenerate__item-logo--top">
                  <img :src="regenerateImg" alt="icon" />
                </div>

                <div class="regenerate__item-logo--bottom">
                  <img :src="regenerateImgActive" alt="icon" />
                </div>
              </div>
              <span> Regenerate Token </span>
            </div>
          </div>

          <WithLoader
            :isLoading="apiKeysLoading"
            horizontalPosition="left"
            extraClass="api-keys-loader"
          >
            <div class="api-item">
              <div class="item-heading">
                <h5>
                  Authorization Header
                </h5>
                <VHint
                  text="To authenticate using the Inkit public API, use the authorization header below"
                  extraClass="integrations-hint"
                  position="right"
                  size="fit"
                  noPadding
                />
              </div>
              <div class="v-pre__wrap">
                <VPre
                  :text="`Authorization: Inkit ${apiToken}`"
                  extraClass="in-account-integrations"
                  withCopy
                ></VPre>
              </div>
            </div>

            <div class="api-item">
              <div class="item-heading">
                <h5>
                  API Token
                </h5>
                <VHint
                  text="To setup webhook, use API Token"
                  extraClass="integrations-hint"
                  position="right"
                  size="fit"
                  noPadding
                />
              </div>

              <div class="v-pre__wrap">
                <VPre :text="apiToken" withCopy></VPre>
              </div>
            </div>

            <p></p>
          </WithLoader>
        </div>

        <div class="inner__wrapper">
          <div class="subheader integrations">
            <span> Integrations </span>

            <div>
              <AccountIntegrationsForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

import Layout from "@/layouts/Layout";

// components
import VSettingsSidebarLayoutHeading from "@/components/VSettingsSidebarLayoutHeading";
import AccountIntegrationsForm from "@/components/AccountIntegrationsForm";
import VButton from "@/components/VButton";
import VHint from "@/components/VHint";
import VPre from "@/components/VPre";

import withToasted from "@/mixins/withToasted";

import regenerateImg from "@/assets/images/regenerate.svg";
import regenerateImgActive from "@/assets/images/regenerate-active.svg";

export default Vue.component("AccountIntegrations", {
  metaInfo: {
    title: "Settings - API/Integrations"
  },

  components: {
    Layout,
    VSettingsSidebarLayoutHeading,
    VButton,
    VPre,
    AccountIntegrationsForm,
    VHint
  },

  mixins: [withToasted],

  data() {
    return {
      regenerateImg,
      regenerateImgActive,
      hovered: false
    };
  },

  methods: {
    refreshToken() {
      this.refreshApiToken({
        onSuccess: () => {
          this.fetchIdentity();
        },

        onError: () => {
          this.errorToast("Failed to refresh API token.");
        }
      });
    },

    ...mapActions("account", ["refreshApiToken", "fetchIdentity"])
  },

  computed: {
    apiToken() {
      return this.getAccount.api_token;
    },

    ...mapGetters("account", ["getAccount", "isLoading", "apiKeysLoading"])
  }
});
</script>

<style lang="scss">
/*.integrations-hint {
  white-space: nowrap;

  [tooltip] {
    &::after {
      //TODO: Fix those
      max-width: 100% !important;
      min-width: fit-content !important;
      left: calc(100% + 6px) !important;
    }

    &::before {
      left: calc(100%);
    }
  }

  @media screen and (max-width: $medium-screen) {
    !*white-space: pre-wrap;*!
  }
}*/

.with-loader__wrapper.api-keys-loader.left.isLoading {
  justify-content: center;
  min-width: 503px;
  min-height: 191px;

  @media screen and (max-width: $medium-screen) {
    min-width: 100%;
  }
}
</style>

<style lang="scss" scoped>
$ns: "account-integrations";

.#{$ns} {
  &__wrapper {
    height: 100%;
  }

  &__inner {
    display: flex;
    margin-bottom: 20px;
    max-width: 868px;

    .api-item {
      &:first-child {
        margin-bottom: 25px;
      }

      .item-heading {
        margin-bottom: 14px;
        display: flex;
        align-items: center;

        h5 {
          margin-right: 20px;
        }
      }
    }

    h5 {
      font-family: Lato-Bold, sans-serif;
      font-size: 15px;
      color: $primary-text-color;
      padding-left: 9px;
    }

    p {
      font-family: Lato-Light, sans-serif;
      font-size: 14px;
      color: $secondary-text-color;
    }

    .subheader {
      margin-bottom: 35px;
      display: flex;
      align-items: center;
      font-family: "Lato-Regular", sans-serif;
      font-size: 16px;
      color: $secondary-text-color;

      &.integrations {
        align-items: flex-start;
        margin-left: 55px;
        flex-direction: column;
      }
    }

    .regenerate {
      cursor: pointer;
      margin-left: 25px;
      display: flex;
      align-items: center;
      font-family: "Lato-Light", sans-serif;
      font-size: 14px;
      color: #b4b2b2;

      img {
        margin-right: 10px;
      }

      &:hover {
        color: $primary-color;
      }

      &__item-logo {
        position: relative;
        width: 20px;
        height: 20px;
        margin-right: 10px;

        &--top,
        &--bottom {
          width: 100%;
          height: 100%;
        }

        img {
          position: absolute;
          left: 0;
          bottom: 0;
        }

        &--top {
          opacity: 1;
        }

        &--bottom {
          opacity: 0;
        }
      }

      &.hovered {
        .regenerate__item-logo {
          &--top {
            opacity: 0;
          }

          &--bottom {
            opacity: 1;
          }
        }
      }
    }

    @media screen and (max-width: $medium-screen) {
      flex-direction: column;

      .subheader.integrations {
        margin-left: 0;
        margin-top: 30px;
      }
    }
  }

  &__outer {
    h3 {
      margin-top: 10px;
      font-size: 20px;
      color: $button-dark-color;
    }
  }
}

@media screen and (max-width: 991px) {
  .v-pre__wrap {
    max-width: 100%;
  }
}
</style>

<style lang="scss">
.in-account-integrations {
  .v-pre {
    span {
      overflow: unset;
      @media screen and (max-width: $small-screen) {
        overflow: hidden;
      }
    }
  }
}
</style>
